/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountsOut,
  CloseBooksIn,
  ClosingOut,
  GetTrialBalanceParams,
  HTTPValidationError,
  MessageResponse,
  PostRentOut,
  ReopenBooksIn,
  ReverseEntryIn,
  TrialBalanceOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listLedgerAccountsResponse200 = {
  data: AccountsOut
  status: 200
}

export type listLedgerAccountsResponseSuccess = (listLedgerAccountsResponse200) & {
  headers: Headers;
};
;

export type listLedgerAccountsResponse = (listLedgerAccountsResponseSuccess)

export const getListLedgerAccountsUrl = () => {




  return `/api/ledger/accounts`
}

/**
 * @summary List Ledger Accounts
 */
export const listLedgerAccounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listLedgerAccountsResponse> => {

  return apiFetch<listLedgerAccountsResponse>(getListLedgerAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLedgerAccountsQueryKey = () => {
    return [
    `/api/ledger/accounts`
    ] as const;
    }


export const getListLedgerAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listLedgerAccounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLedgerAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLedgerAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLedgerAccounts>>> = ({ signal }) => listLedgerAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLedgerAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLedgerAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listLedgerAccounts>>>
export type ListLedgerAccountsQueryError = unknown


export function useListLedgerAccounts<TData = Awaited<ReturnType<typeof listLedgerAccounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLedgerAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLedgerAccounts>>,
          TError,
          Awaited<ReturnType<typeof listLedgerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLedgerAccounts<TData = Awaited<ReturnType<typeof listLedgerAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLedgerAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLedgerAccounts>>,
          TError,
          Awaited<ReturnType<typeof listLedgerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLedgerAccounts<TData = Awaited<ReturnType<typeof listLedgerAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLedgerAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Ledger Accounts
 */

export function useListLedgerAccounts<TData = Awaited<ReturnType<typeof listLedgerAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLedgerAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLedgerAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getTrialBalanceResponse200 = {
  data: TrialBalanceOut
  status: 200
}

export type getTrialBalanceResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getTrialBalanceResponseSuccess = (getTrialBalanceResponse200) & {
  headers: Headers;
};
export type getTrialBalanceResponseError = (getTrialBalanceResponse422) & {
  headers: Headers;
};

export type getTrialBalanceResponse = (getTrialBalanceResponseSuccess | getTrialBalanceResponseError)

export const getGetTrialBalanceUrl = (params?: GetTrialBalanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ledger/trial-balance?${stringifiedParams}` : `/api/ledger/trial-balance`
}

/**
 * @summary Get Trial Balance
 */
export const getTrialBalance = async (params?: GetTrialBalanceParams, options?: Parameters<typeof apiFetch>[1]): Promise<getTrialBalanceResponse> => {

  return apiFetch<getTrialBalanceResponse>(getGetTrialBalanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrialBalanceQueryKey = (params?: GetTrialBalanceParams,) => {
    return [
    `/api/ledger/trial-balance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTrialBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = HTTPValidationError>(params?: GetTrialBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrialBalanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrialBalance>>> = ({ signal }) => getTrialBalance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrialBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getTrialBalance>>>
export type GetTrialBalanceQueryError = HTTPValidationError


export function useGetTrialBalance<TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = HTTPValidationError>(
 params: undefined |  GetTrialBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialBalance>>,
          TError,
          Awaited<ReturnType<typeof getTrialBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrialBalance<TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = HTTPValidationError>(
 params?: GetTrialBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialBalance>>,
          TError,
          Awaited<ReturnType<typeof getTrialBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrialBalance<TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = HTTPValidationError>(
 params?: GetTrialBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Trial Balance
 */

export function useGetTrialBalance<TData = Awaited<ReturnType<typeof getTrialBalance>>, TError = HTTPValidationError>(
 params?: GetTrialBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrialBalance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrialBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getClosingResponse200 = {
  data: ClosingOut
  status: 200
}

export type getClosingResponseSuccess = (getClosingResponse200) & {
  headers: Headers;
};
;

export type getClosingResponse = (getClosingResponseSuccess)

export const getGetClosingUrl = () => {




  return `/api/ledger/closing`
}

/**
 * @summary Get Closing
 */
export const getClosing = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getClosingResponse> => {

  return apiFetch<getClosingResponse>(getGetClosingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClosingQueryKey = () => {
    return [
    `/api/ledger/closing`
    ] as const;
    }


export const getGetClosingQueryOptions = <TData = Awaited<ReturnType<typeof getClosing>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClosing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClosingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClosing>>> = ({ signal }) => getClosing({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClosing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClosingQueryResult = NonNullable<Awaited<ReturnType<typeof getClosing>>>
export type GetClosingQueryError = unknown


export function useGetClosing<TData = Awaited<ReturnType<typeof getClosing>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClosing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClosing>>,
          TError,
          Awaited<ReturnType<typeof getClosing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClosing<TData = Awaited<ReturnType<typeof getClosing>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClosing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClosing>>,
          TError,
          Awaited<ReturnType<typeof getClosing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClosing<TData = Awaited<ReturnType<typeof getClosing>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClosing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Closing
 */

export function useGetClosing<TData = Awaited<ReturnType<typeof getClosing>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClosing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClosingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type closeBooksResponse200 = {
  data: ClosingOut
  status: 200
}

export type closeBooksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type closeBooksResponseSuccess = (closeBooksResponse200) & {
  headers: Headers;
};
export type closeBooksResponseError = (closeBooksResponse422) & {
  headers: Headers;
};

export type closeBooksResponse = (closeBooksResponseSuccess | closeBooksResponseError)

export const getCloseBooksUrl = () => {




  return `/api/ledger/closing/close`
}

/**
 * @summary Close Books
 */
export const closeBooks = async (closeBooksIn: CloseBooksIn, options?: Parameters<typeof apiFetch>[1]): Promise<closeBooksResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<closeBooksResponse>(getCloseBooksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(closeBooksIn)
  }
);}





export const getCloseBooksMutationKey = () => ['closeBooks'] as const;

export const getCloseBooksMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeBooks>>, TError,CloseBooksMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeBooks>>, TError,CloseBooksMutationVariables, TContext> => {

const mutationKey = getCloseBooksMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeBooks>>, CloseBooksMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  closeBooks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseBooksMutationResult = NonNullable<Awaited<ReturnType<typeof closeBooks>>>
    export type CloseBooksMutationBody = CloseBooksIn
    export type CloseBooksMutationError = HTTPValidationError
    export type CloseBooksMutationVariables = {data: CloseBooksIn}

    /**
 * @summary Close Books
 */
export const useCloseBooks = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeBooks>>, TError,CloseBooksMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeBooks>>,
        TError,
        CloseBooksMutationVariables,
        TContext
      > => {
      return useMutation(getCloseBooksMutationOptions(options), queryClient);
    }
    export type reopenBooksResponse200 = {
  data: ClosingOut
  status: 200
}

export type reopenBooksResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reopenBooksResponseSuccess = (reopenBooksResponse200) & {
  headers: Headers;
};
export type reopenBooksResponseError = (reopenBooksResponse422) & {
  headers: Headers;
};

export type reopenBooksResponse = (reopenBooksResponseSuccess | reopenBooksResponseError)

export const getReopenBooksUrl = () => {




  return `/api/ledger/closing/reopen`
}

/**
 * Admins only, because reopening changes what's already been reported.
 * @summary Reopen Books
 */
export const reopenBooks = async (reopenBooksIn: ReopenBooksIn, options?: Parameters<typeof apiFetch>[1]): Promise<reopenBooksResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<reopenBooksResponse>(getReopenBooksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reopenBooksIn)
  }
);}





export const getReopenBooksMutationKey = () => ['reopenBooks'] as const;

export const getReopenBooksMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenBooks>>, TError,ReopenBooksMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenBooks>>, TError,ReopenBooksMutationVariables, TContext> => {

const mutationKey = getReopenBooksMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenBooks>>, ReopenBooksMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reopenBooks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenBooksMutationResult = NonNullable<Awaited<ReturnType<typeof reopenBooks>>>
    export type ReopenBooksMutationBody = ReopenBooksIn
    export type ReopenBooksMutationError = HTTPValidationError
    export type ReopenBooksMutationVariables = {data: ReopenBooksIn}

    /**
 * @summary Reopen Books
 */
export const useReopenBooks = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenBooks>>, TError,ReopenBooksMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenBooks>>,
        TError,
        ReopenBooksMutationVariables,
        TContext
      > => {
      return useMutation(getReopenBooksMutationOptions(options), queryClient);
    }
    export type postRentNowResponse200 = {
  data: PostRentOut
  status: 200
}

export type postRentNowResponseSuccess = (postRentNowResponse200) & {
  headers: Headers;
};
;

export type postRentNowResponse = (postRentNowResponseSuccess)

export const getPostRentNowUrl = () => {




  return `/api/ledger/post-rent`
}

/**
 * Safe to press any number of times: what's already posted is never posted again.
 * @summary Post Rent Now
 */
export const postRentNow = async ( options?: Parameters<typeof apiFetch>[1]): Promise<postRentNowResponse> => {

  return apiFetch<postRentNowResponse>(getPostRentNowUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPostRentNowMutationKey = () => ['postRentNow'] as const;

export const getPostRentNowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRentNow>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postRentNow>>, TError,void, TContext> => {

const mutationKey = getPostRentNowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRentNow>>, void> = () => {


          return  postRentNow(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostRentNowMutationResult = NonNullable<Awaited<ReturnType<typeof postRentNow>>>

    export type PostRentNowMutationError = unknown


    /**
 * @summary Post Rent Now
 */
export const usePostRentNow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRentNow>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postRentNow>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostRentNowMutationOptions(options), queryClient);
    }
    export type reverseLedgerEntryResponse200 = {
  data: MessageResponse
  status: 200
}

export type reverseLedgerEntryResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reverseLedgerEntryResponseSuccess = (reverseLedgerEntryResponse200) & {
  headers: Headers;
};
export type reverseLedgerEntryResponseError = (reverseLedgerEntryResponse422) & {
  headers: Headers;
};

export type reverseLedgerEntryResponse = (reverseLedgerEntryResponseSuccess | reverseLedgerEntryResponseError)

export const getReverseLedgerEntryUrl = (entryId: number,) => {




  return `/api/ledger/entries/${entryId}/reverse`
}

/**
 * @summary Reverse Ledger Entry
 */
export const reverseLedgerEntry = async (entryId: number,
    reverseEntryIn: ReverseEntryIn, options?: Parameters<typeof apiFetch>[1]): Promise<reverseLedgerEntryResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<reverseLedgerEntryResponse>(getReverseLedgerEntryUrl(entryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reverseEntryIn)
  }
);}





export const getReverseLedgerEntryMutationKey = () => ['reverseLedgerEntry'] as const;

export const getReverseLedgerEntryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseLedgerEntry>>, TError,ReverseLedgerEntryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reverseLedgerEntry>>, TError,ReverseLedgerEntryMutationVariables, TContext> => {

const mutationKey = getReverseLedgerEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reverseLedgerEntry>>, ReverseLedgerEntryMutationVariables> = (props) => {
          const {entryId,data} = props ?? {};

          return  reverseLedgerEntry(entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReverseLedgerEntryMutationResult = NonNullable<Awaited<ReturnType<typeof reverseLedgerEntry>>>
    export type ReverseLedgerEntryMutationBody = ReverseEntryIn
    export type ReverseLedgerEntryMutationError = HTTPValidationError
    export type ReverseLedgerEntryMutationVariables = {entryId: number;data: ReverseEntryIn}

    /**
 * @summary Reverse Ledger Entry
 */
export const useReverseLedgerEntry = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reverseLedgerEntry>>, TError,ReverseLedgerEntryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reverseLedgerEntry>>,
        TError,
        ReverseLedgerEntryMutationVariables,
        TContext
      > => {
      return useMutation(getReverseLedgerEntryMutationOptions(options), queryClient);
    }
